import { type FC, type ReactNode } from "react";

import { Badge, Box, Group } from "@mantine/core";

import { Unsaved } from "./messages.generated";

interface FieldLabelProps {
    children: ReactNode;
    hasChanges?: boolean;
    className?: string;
}

export const FieldLabel: FC<FieldLabelProps> = ({ children, hasChanges = false, className }) => {
    return (
        <Group gap="xs" className={className}>
            <Box component="span">{children}</Box>
            {hasChanges && (
                <Badge color="black" variant="light">
                    <Unsaved />
                </Badge>
            )}
        </Group>
    );
};
